import { object, string } from 'yup';
import './utils/email';

const NewsletterValidation = object().shape({
  email: string()
    .email('validations.email.format')
    .required('validations.email.required'),
});

export default NewsletterValidation;
